export default __webpack_public_path__ + "static/media/key_strength_icon.40e9e2c5.svg";